var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_3664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.24 19.26C6.048 19.26 5.856 19.187 5.71 19.04C3.962 17.293 3 14.971 3 12.5C3 10.029 3.962 7.70698 5.71 5.95998C6.003 5.66698 6.478 5.66698 6.771 5.95998C7.064 6.25298 7.064 6.72798 6.771 7.02098C5.306 8.48398 4.5 10.43 4.5 12.5C4.5 14.57 5.306 16.516 6.771 17.979C7.064 18.271 7.064 18.747 6.771 19.04C6.624 19.187 6.432 19.26 6.24 19.26Z",
    fill: "#FFC731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12 21.3801C3.928 21.3801 3.736 21.3071 3.59 21.1601C1.275 18.8451 0 15.7701 0 12.5001C0 9.23011 1.275 6.15511 3.59 3.84011C3.883 3.54711 4.358 3.54711 4.651 3.84011C4.944 4.13311 4.944 4.60811 4.651 4.90111C2.619 6.93211 1.5 9.63111 1.5 12.5001C1.5 15.3691 2.619 18.0681 4.65 20.1001C4.943 20.3931 4.943 20.8681 4.65 21.1611C4.504 21.3071 4.312 21.3801 4.12 21.3801Z",
    fill: "#FFC731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.88 21.3799C19.688 21.3799 19.496 21.3069 19.35 21.1599C19.057 20.8669 19.057 20.3919 19.35 20.0989C21.382 18.0669 22.5 15.3689 22.5 12.4989C22.5 9.62891 21.381 6.93091 19.35 4.89891C19.057 4.60591 19.057 4.13091 19.35 3.83791C19.643 3.54491 20.118 3.54491 20.411 3.83791C22.725 6.15491 24 9.22991 24 12.4999C24 15.7699 22.725 18.8449 20.41 21.1599C20.264 21.3069 20.072 21.3799 19.88 21.3799Z",
    fill: "#FFC731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.76 19.26C17.568 19.26 17.376 19.187 17.23 19.04C16.937 18.747 16.937 18.272 17.23 17.979C18.694 16.516 19.5 14.57 19.5 12.5C19.5 10.43 18.694 8.48398 17.229 7.02098C16.936 6.72898 16.936 6.25298 17.229 5.95998C17.522 5.66698 17.997 5.66698 18.29 5.95998C20.038 7.70698 21 10.029 21 12.5C21 14.971 20.038 17.293 18.29 19.04C18.144 19.187 17.952 19.26 17.76 19.26Z",
    fill: "#FFC731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.823 20.5003C9.716 20.5003 9.607 20.4773 9.505 20.4293C9.181 20.2773 9.009 19.9173 9.095 19.5693L10.541 13.7503H7.75C7.47 13.7503 7.213 13.5943 7.084 13.3453C6.955 13.0963 6.976 12.7963 7.138 12.5673L12.621 4.81731C12.821 4.53531 13.186 4.42631 13.505 4.55131C13.826 4.67631 14.021 5.00331 13.977 5.34431L13.352 10.2503H16.25C16.533 10.2503 16.792 10.4093 16.919 10.6613C17.047 10.9133 17.022 11.2163 16.855 11.4443L10.428 20.1943C10.283 20.3923 10.056 20.5003 9.823 20.5003Z",
    fill: "#FFC731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_3664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.23a4a42f4f53aafff56d4152fdcb3106.svg";
export { ForwardRef as ReactComponent };